module.exports = __webpack_public_path__ + "media/images/kahndo_solutions-bec4051f41894588b535f7dcc835c696.png";